import React, { useState, useEffect } from "react";
import Slider from "rc-slider";
import { convertToLakhMin } from "@utils/inrFormatter";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import {
  Wrapper,
  MinMaxText,
  CurrencyText,
  RecommendedRangeContainer,
  RecommendedRangeText
} from "./styles";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { setGlobalData } from "@actions/setGlobalData";
// import { debounce } from "utils/lodash";
import GreenBrace from "./idvRangeBrace";
import useGetRecommendedRangeWidth from "hooks/useGetRecommendedRangeWidth";
import { getRequestpayload } from "@utils/index";

interface Props {
  min: number;
  max: number;
  singleRow?: boolean;
  selectedValue: number;
  setSelectedValue: Function;
  getSliderCurrentValue?: Function;
  setSliderInteracted?: Function;
  threshHold: number;
  setSliderInteractionValue?: Function;
  showRecommendedRange?: boolean;
  styles?: any;
  onSlideEnd?: (value: number) => void;
}

const IdvSlider = ({
  min = 0,
  max = 100000,
  setSelectedValue,
  selectedValue = 0,
  setSliderInteracted,
  threshHold,
  setSliderInteractionValue,
  showRecommendedRange,
  styles = {},
  onSlideEnd,
  ...props
}: Props) => {
  const [currentSliderValue, setCurrentSliderValue] = useState(selectedValue);

  useEffect(() => {
    setCurrentSliderValue(selectedValue);
  }, [selectedValue]);

  const setState = (val) => {
    setSelectedValue(val);
    setCurrentSliderValue(val);
  };

  const { data, journey } = getRequestpayload();

  const handleFinalValue = (value) => {
    setState(value);

    if (onSlideEnd) {
      onSlideEnd(value);
    }

    triggerAnalyticEvent({
      edata: {
        product: data.product,
        action_name: "idv_slider_interacted",
        action_type: "slider_interacted",
        initial_idv: selectedValue,
        recommended_idv: threshHold,
        selected_idv: value
      },
      odata: {
        journey
      },
      event_name: "action"
    });
    setGlobalData({
      globalData: {
        idv_error: false
      }
    });
  };

  console.log({ showRecommendedRange });

  return (
    <>
      <Wrapper
        alignItems="center"
        justifyContent="space-evenly"
        flexDirection={"column"}
        style={styles.wrapper}
        id="idv-slider-wrapper"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            marginBottom: "0.75rem"
          }}
        >
          <Flex flexDirection="column" style={{ width: "max-content" }}>
            <MinMaxText>
              ₹{convertToLakhMin(min)}{" "}
              <CurrencyText>lakh</CurrencyText>
            </MinMaxText>
          </Flex>
          <Flex
            flexDirection="column"
            style={{ width: "max-content" }}
            alignItems="flex-end"
          >
            <MinMaxText>
              ₹{convertToLakhMin(max)}{" "}
              <CurrencyText>lakh</CurrencyText>
            </MinMaxText>
          </Flex>
        </div>
        <div
          style={{
            position: "relative",
            width: "100%",
            marginBottom: "28px",
            ...styles.sliderContainer
          }}
          id="idv-slider"
        >
          <Slider
            min={min}
            max={max}
            value={currentSliderValue || 0}
            step={1}
            railStyle={{
              height: 5,
              background: "#C8D0DB",
              borderRadius: 10,
              ...styles.rail
            }}
            trackStyle={{
              backgroundColor: "#38A548",
              height: 6,
              ...styles.track
            }}
            handleStyle={{
              height: 24,
              width: 24,
              marginTop: -10,
              background: "#3AC77E",
              boxShadow:
                "0px 1px 2px 0px #99E5A4 inset, 0px -1px 2px 0px #13864A inset",
              border: "1px solid #3AC77E",
              ...styles.handle
            }}
            onChange={(value) => {
              setState(value);
              if (typeof setSliderInteracted === "function") {
                setSliderInteracted(true);
              }
              if (typeof setSliderInteractionValue === "function") {
                setSliderInteractionValue(value);
              }
            }}
            onAfterChange={(value) => {
              handleFinalValue(value);
            }}
          />
          {showRecommendedRange && (
            <>
              <RecommendedRangeContainer
                style={{ width: useGetRecommendedRangeWidth(min, max) }}
              >
                <div style={{ width: "100%", height: "2rem" }}>
                  <GreenBrace />
                </div>
                <RecommendedRangeText>Recommended range</RecommendedRangeText>
              </RecommendedRangeContainer>
            </>
          )}
        </div>
      </Wrapper>
    </>
  );
};

export default IdvSlider;
